<template>
  <el-table-column
    prop="customer_county"
    sortable="custom"
    label="Megye"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.customer_county }}</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer_address.county.name',
};
</script>
